import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFireworks = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "120px",
	height: "120px",
	viewBox: "0 0 120 120",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Group 15" }), /* @__PURE__ */ _jsx("g", {
		id: "New-Years-Day",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "New-Year's-Day-1",
			transform: "translate(-452.000000, -140.000000)",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Group-15",
				transform: "translate(452.000000, 140.000000)",
				children: [
					/* @__PURE__ */ _jsx("polygon", {
						id: "Fill-1",
						fill: "currentcolor",
						points: "11.0339331 0 10.1926406 11.7900504 -1.32720765e-15 17.7822053 10.9547351 22.2262624 13.5025216 33.7697528 21.114501 24.7247369 32.8806426 25.8678787 26.6314675 15.8351286 31.3549592 4.99694913 19.8802067 7.84060768"
					}),
					/* @__PURE__ */ _jsx("polygon", {
						id: "Fill-2",
						fill: "currentcolor",
						points: "100.118299 8.2091028 88.6435465 5.36693855 93.3670382 16.2036237 87.1178631 26.2378681 98.8840047 25.0947264 106.495984 34.1397422 109.045265 22.5962518 120 18.1521948 109.807359 12.1600398 108.966067 0.368495112"
					}),
					/* @__PURE__ */ _jsx("polygon", {
						id: "Fill-3",
						fill: "currentcolor",
						points: "61.1063819 3.44929955 54.5150115 16.8053795 39.7737127 18.9482099 50.4400473 29.3440757 47.9221468 44.0256024 61.1063819 37.0935309 74.290617 44.0256024 71.7727165 29.3440757 82.4390511 18.9482099 67.6977523 16.8053795"
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Group-14",
						transform: "translate(9.420534, 36.231916)",
						stroke: "currentcolor",
						strokeWidth: 4,
						children: [
							/* @__PURE__ */ _jsx("path", {
								d: "M19.4259386,0 C19.4259386,0 36.0321275,27.7521948 38.273582,83.6809663",
								id: "Stroke-4"
							}),
							/* @__PURE__ */ _jsx("path", {
								d: "M2.6544153e-15,28.3917564 C2.6544153e-15,28.3917564 21.2758857,52.5172779 20.3299919,83.6809663",
								id: "Stroke-6"
							}),
							/* @__PURE__ */ _jsx("path", {
								d: "M81.7805118,0 C81.7805118,0 65.1743229,27.7521948 62.9328684,83.6809663",
								id: "Stroke-8"
							}),
							/* @__PURE__ */ _jsx("path", {
								d: "M101.20645,28.3917564 C101.20645,28.3917564 79.9305647,52.5172779 80.8764585,83.6809663",
								id: "Stroke-10"
							}),
							/* @__PURE__ */ _jsx("line", {
								x1: 51.1646348,
								y1: 83.6809663,
								x2: 51.1646348,
								y2: 32.8746653,
								id: "Stroke-12"
							})
						]
					})
				]
			})
		})
	})]
});
export default SvgFireworks;
